import React from 'react';
import { useSelector } from 'react-redux';
import { licenseTypes } from '@/data/data-selectors';
import { InspectionText } from '@/property-inspections/constants';
import { DetailsInfoDisplay } from './details-info-display';

const LICENSE_INFORMATION = 'License Information';
const OCCUPANCY_ALLOWED = 'Occupancy allowed';
const BEDROOM_ALLOWED = 'Bedroom allowed';

const LAST_INSPECTION_RESULT_LABEL = 'Inspection Result';
const LAST_INSPECTION_DATE_LABEL = 'Last Inspection Date';

export function LicenseInfoMod(props) {
  const {
    strLicense,
    occupancyAllowed,
    bedroomsLicensed,
    inspectionResult,
    inspectionDate,
  } = props;
  const licenseTypesData = useSelector(licenseTypes);
  const strLicenseLabel = licenseTypesData?.str?.name;

  // TODO: We should also check if the label is not a false-y value (is not an empty string)
  if ((strLicenseLabel && strLicense) || bedroomsLicensed || occupancyAllowed) {
    return (
      <DetailsInfoDisplay
        title={LICENSE_INFORMATION}
        left={[
          [strLicenseLabel, strLicense],
          ...[
            inspectionDate ? [LAST_INSPECTION_DATE_LABEL, inspectionDate] : [],
          ],
          ...[
            inspectionResult
              ? [LAST_INSPECTION_RESULT_LABEL, InspectionText[inspectionResult]]
              : [],
          ],
        ]}
        right={[
          [BEDROOM_ALLOWED, bedroomsLicensed],
          [OCCUPANCY_ALLOWED, occupancyAllowed],
        ]}
      />
    );
  }
  return null;
}
